import React, { Component } from 'react'
import axios from "axios";
import Masonry from '../../../Gallery/Masonry/MasonryLayout';
import { GetBaseUrl } from '@/utils/ConfigHelper'
import GalleryDialog from '../../../Gallery/GalleryDialog/GalleryDialog';
import ShareDialog from '../../MyVideo/ShareDialog/ShareDialog'
import OneBtnDialog from "../../../Common/OneBtnDialog/OneBtnDialog";
import { _getTemplateById } from '../../../Home';
import { _onVideoLikedButtonClicked } from '../../../Routers/designSelect';
import { connect } from 'react-redux';
import CopyToClipboard from 'copy-to-clipboard'
import { SetIsShowLoginDialog } from '../../../Interface'
import './MyLikedVideo.scss'
import NewGalleryDialog from '../../../Gallery/NewGalleryDialog';

import EmptyVideo from '../../MyVideo/emptyVideo/emptyVideo';

import i18n from '../../../i18n'

class MyLikedVideo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isGalleryDialogOpen: false,
            selectedVideoId: null,
            gallerys: undefined,
            gallerysCount: undefined,
            videoInfo: undefined,
            filterRequested: true,
            currentPage: 0,
            cardsPerPage: 32,
            isOpenShareDialog: false,
            dialogType: "shareSuccess",
            getOriginalTemplateInfo: false,
            originalTemplate: {},
            isNewGalleryDialogOpen: false,

            // GalleryDialog에서 다른 유저 비디오 누른 경우 뒤로가기 기능을 위해 데이터를 저장한다.
            stackedVideoIds: [],
            galleryDialogSameTemplateVideos: [],
        }
    }

    templateGroupMap = {}

    scrollTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    async componentDidMount() {
        this.getTemplates()
        this.scrollTop()

        const workspaceArea = document.getElementsByClassName('default-workspace-area')[0]
        if (workspaceArea) {
            workspaceArea.addEventListener('scroll', this.onBodyScroll)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.endpoint !== nextProps.endpoint) {
            this.setState({ currentPage: 0, gallerys: undefined }, () => {
                this.getTemplates()
                this.scrollTop()
            })
        }
    }

    onBodyScroll = e => {
        const workspaceArea = document.getElementsByClassName('default-workspace-area')[0]
        if (!workspaceArea) return

        const { scrollHeight } = workspaceArea
        const { innerHeight, scrollY } = window
        if (innerHeight + scrollY + 1200 > scrollHeight) this.getTemplates()
    }

    isLoading = false
    getTemplates = async () => {
        if (this.isLoading) return
        let { gallerys } = this.state

        if (Array.isArray(gallerys) && this.state.gallerys.length >= this.state.gallerysCount) return
        this.isLoading = true
        const token = localStorage.getItem("token");
        const pageIndex = this.state.currentPage
        const pageItemCount = this.state.cardsPerPage;
        const galleryInfo = await axios.get(`${GetBaseUrl()}/apis/videos/${this.props.endpoint}?offset=${pageIndex}&limit=${pageItemCount}`, { headers: { Authorization: `Bearer ${token}` } })
        const { list, count } = galleryInfo.data.data

        if (Array.isArray(gallerys)) gallerys.push(...list)
        else gallerys = list

        this.setState({
            gallerys,
            gallerysCount: count,
            currentPage: pageIndex + 1
        })
        this.isLoading = false
    }

    GetVideoInfo = async _id => {
        const token = localStorage.getItem("token")
        const response = await axios.get(`${GetBaseUrl()}/api/video/gallery-detail?id=${_id}`, { headers: { Authorization: `Bearer ${token}` } })

        const videoInfo = response.data
        this.setState({ videoInfo })

        const { gallerys } = this.state
        if (Array.isArray(gallerys)) {
            for (let i = 0; i < gallerys.length; i++) {
                if (gallerys[i]._id === videoInfo._id) {
                    gallerys[i].isLike = videoInfo.isLike
                    gallerys[i].comments = Array.isArray(videoInfo.comments) ? videoInfo.comments.length : 0
                    this.setState({ gallerys })
                    break
                }
            }
        }
        return videoInfo
    }

    getTemplateById = async (videoId) => {
        return _getTemplateById(videoId)
    };

    onThumbnailClicked = (videoId, previouslyDragged) => async e => {
        if (previouslyDragged) { return; }

        this.OpenGalleryDialog(videoId)
    }

    OpenGalleryDialog = async (videoId) => {
        //   const token = localStorage.getItem("token")
        const videoInfo = await this.GetVideoInfo(videoId)
        axios.patch(`${GetBaseUrl()}/apis/videos/${videoId}/views/increase`).catch(e => console.log(e))

        try {
            // 다른 유저들이 만든 비디오 목록
            // let galleryDialogSameTemplateVideos = []
            // if (videoInfo && videoInfo.template) {
            //   const galleryInfo = await axios.get(`${GetBaseUrl()}/api/video/gallery-video?offset=${0}&limit=${16}&templateId=${videoInfo.template._id}`, { headers: { Authorization: `Bearer ${token}` } })
            //   const { videos } = galleryInfo.data
            //   galleryDialogSameTemplateVideos = videos
            // }

            axios.patch(`${GetBaseUrl()}/apis/videos/${videoId}/views/increase`).catch(e => console.log(e))
            this.setState({ isNewGalleryDialogOpen: true, galleryDialogSameTemplateVideos: [] });
        }
        catch (e) {
            console.log(e)
        }
    }

    moveOriginanlTemplate = async () => {
        if (this.state.videoInfo) {
            try {
                const res = await this.getTemplateById(this.state.videoInfo.template._id);

                if (!this.templateGroupMap[res[0].groupName]) {
                    const groupResponse = await axios.post(`${GetBaseUrl()}/api/template/group-info`, { id: this.state.videoInfo.template._id })
                    this.templateGroupMap[res[0].groupName] = groupResponse.data
                }

                this.setState({
                    originalTemplate: res[0],
                    getOriginalTemplateInfo: true,
                    isOriginalDesignDialogOpened: true
                })
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    handleClickGalleryDialogReturnBtn = () => {
        const { stackedVideoIds } = this.state

        if (stackedVideoIds.length === 0) return

        const lastVideoId = stackedVideoIds[stackedVideoIds.length - 1]
        const newStackedVideoIds = stackedVideoIds.filter(id => lastVideoId !== id)
        this.setState({ stackedVideoIds: newStackedVideoIds }, () => {
            this.OpenGalleryDialog(lastVideoId)
        })
    }

    handleNewGalleryDialogClose = () => {
        this.setState({ isNewGalleryDialogOpen: false, stackedVideoIds: [] })
    }

    closeGalleryDialog = () => {
        this.setState({ isGalleryDialogOpen: false, stackedVideoIds: [] })
    }

    closeOrigianlDialog = () => this.setState({ isOriginalDesignDialogOpened: false, stackedVideoIds: [] })

    updateSelectedTemplate = async (templateId) => {
        const res = await this.getTemplateById(templateId)
        this.setState({ originalTemplate: res[0] })
    }

    // 갤러리 다이얼로그 하나 

    // 디자인 셀렉트 팝업 다이얼로그 하나
    onVideoLikedButtonClicked = (selectedVideo, likedVideos) => e => {
        _onVideoLikedButtonClicked(this, selectedVideo, likedVideos);
    };

    shareClick = (videoInfo) => (e) => {
        e.stopPropagation()
        this.setState({ isOpenShareDialog: true, videoInfo })
    }
    closeShareDialog = () => this.setState({ isOpenShareDialog: false })

    clickShareItem = async method => {
        const item = this.state.videoInfo
        try {
            const response = await axios.get(`${GetBaseUrl()}/api/video/share-link?id=${item._id}`)
            if (response && response.data && response.data.result === 'success') {
                const { shareId } = response.data
                const shareLink = window.location.origin + `/share?id=${shareId}`
                const { invokeCSharpAction } = window
                const isXamarin = invokeCSharpAction
                switch (method) {
                    case 'twitter':
                    case 'facebook':
                        let targetLink = 'about:blank'
                        if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
                        else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

                        if (isXamarin) window.location.href = targetLink
                        else {
                            const windowRef = window.open(targetLink, '_blank')
                            if (!windowRef) this.setState({
                                isBtnDialogOpened: true,
                                dialogType: "shareLinkBlock"
                            })
                        }
                        break
                    case 'linkxamarin':
                        window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
                        break

                    case 'link':
                    default:
                        CopyToClipboard(shareLink)
                        this.setState({
                            isBtnDialogOpened: true,
                            dialogType: "shareSuccess"
                        })
                        break
                }
            }
        }
        catch (e) {
            this.setState({
                isBtnDialogOpened: true,
                dialogType: "shareFail"
            })
        }
    }
    popupHandleCloseBtn = () => this.setState({ isBtnDialogOpened: false })

    heartClick = async (id, e) => {
        e.stopPropagation()
        const token = localStorage.getItem("token");
        const { gallerys, videoInfo } = this.state
        if (token) {
            if (Array.isArray(gallerys)) {
                try {
                    for (let i = 0; i < gallerys.length; i++) {
                        if (gallerys[i]._id === id) {
                            if (!gallerys[i].isLike) {
                                gallerys[i].isLike = true
                                gallerys[i].likeMembers++
                                if (videoInfo) {
                                    videoInfo.isLike = true
                                    videoInfo.likeMembers++
                                }
                                this.setState({ gallerys, videoInfo, date: Date.now() })
                                await axios.post(`${GetBaseUrl()}/api/video/set-like`, { id }, { headers: { Authorization: `Bearer ${token}` } });
                            }
                            else {
                                gallerys[i].isLike = false
                                gallerys[i].likeMembers--
                                if (videoInfo) {
                                    videoInfo.isLike = false
                                    videoInfo.likeMembers--
                                }
                                this.setState({ gallerys, videoInfo, date: Date.now() })
                                await axios.post(`${GetBaseUrl()}/api/video/unset-like`, { id }, { headers: { Authorization: `Bearer ${token}` } });
                            }
                            break
                        }
                    }
                }
                catch (e) {
                    this.setState({
                        dialogType: "severError",
                        isBtnDialogOpened: true
                    })
                }
            }
        } else {
            this.loginRequest()
        }
    }

    loginRequest = () => {
        SetIsShowLoginDialog(true)
    }

    handleClickHashtag = (hashtag) => {
        const nxtPath = `/gallery`

        if (!hashtag || nxtPath === window.location.pathname) return

        this.props.history.push(nxtPath, { hashtag: hashtag.replace('#', '') })
    }

    handleUpdateVideoHashTag = async (hashtagString) => {
        const { videoInfo, gallerys } = this.state

        const token = localStorage.getItem("token");
        const _id = videoInfo._id

        try {
            let hashtag = ''
            if (hashtagString === '#') {
                hashtag = ''
            }
            else {
                hashtagString.split('#').forEach((tag, idx) => {
                    if (idx > 0) {
                        hashtag += (idx === 1) ? `#${tag}` : ` #${tag}`
                    }
                })
            }

            const res = await axios.patch(
                `${GetBaseUrl()}/apis/videos/${_id}/hashtag`,
                { hashtag },
                { headers: { Authorization: `Bearer ${token}` } })

            if (res.data.message === 'success') {
                let newGallerys = gallerys.map((v, idx) => {
                    if (v._id === videoInfo._id) {
                        v.hashtag = hashtag
                    }
                    return v
                })

                this.setState({ hashtagString: '', gallerys: newGallerys }, () => {
                    const videoInfo = this.GetVideoInfo(_id)
                    this.setState({ videoInfo })
                })
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    handleClickGoSeeMoreVideos = (templateId) => {
        const curTemplateId = templateId
        this.props.history.push({
            pathname: '/gallery',
            state: {
                curTemplateId
            }
        })
    }

    handleClickSameTemplate = (videoId) => {
        const { stackedVideoIds, videoInfo } = this.state
        if (!videoId || !videoInfo || videoId === videoInfo._id) return

        try {
            const newStackedVideoIds = stackedVideoIds.map(e => e)
            newStackedVideoIds.push(videoInfo._id)

            this.setState({ stackedVideoIds: newStackedVideoIds }, () => {
                this.OpenGalleryDialog(videoId)
            });
        }
        catch (e) {
            console.log(e)
            return null
        }
    }

    renderGalleryList = () => {
        const {
            gallerys,
            videoInfo,
            isOriginalDesignDialogOpened,
            originalTemplate,
            getOriginalTemplateInfo,
            date,
            galleryDialogSameTemplateVideos,
            stackedVideoIds,
            isNewGalleryDialogOpen
        } = this.state
        const { history, lang } = this.props

        if (Array.isArray(gallerys) && gallerys.length === 0) {
            return <EmptyVideo
                onViewAllFreeVideosButtonClicked={this.onViewAllFreeVideosButtonClicked}
                text1={i18n.t("DefaultView.no.search.result")}
                img="https://front.videomonster.com/images-u6yd72dy/web/Empty-icon.png"
            >
            </EmptyVideo>;
        }

        return (
            <div className='my-liked-video-root'>
                <Masonry
                    {...this.props}
                    history={history}
                    lang={lang}
                    gallerys={gallerys}
                    onThumbnailClicked={this.onThumbnailClicked}
                    shareClick={this.shareClick}
                    onHeartClick={this.heartClick}
                    disableAnimation={true}
                />
                {/* <GalleryDialog
                    {...this.props}
                    open={this.state.isGalleryDialogOpen}
                    videoInfo={videoInfo}
                    isOriginalDesignDialogOpened={isOriginalDesignDialogOpened}
                    moveOriginanlTemplate={this.moveOriginanlTemplate}
                    templateGroupMap={this.templateGroupMap}
                    originalTemplate={originalTemplate}
                    getOriginalTemplateInfo={getOriginalTemplateInfo}
                    closeGalleryDialog={this.closeGalleryDialog}
                    closeOrigianlDialog={this.closeOrigianlDialog}
                    updateSelectedTemplate={this.updateSelectedTemplate}
                    onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
                    loginRequest={this.loginRequest}
                    clickShareItem={this.clickShareItem}
                    updateVideoInfo={this.GetVideoInfo}
                    heartClick={this.heartClick}
                    date={date}
                    onClickSameTemplate={this.handleClickSameTemplate}
                    onClickGoSeeMoreVideos={this.handleClickGoSeeMoreVideos}
                    onClickReturnBtn={this.handleClickGalleryDialogReturnBtn}
                    onClickHashTag={this.handleClickHashtag}
                    onUpdateHashTag={this.handleUpdateVideoHashTag}
                    galleryDialogSameTemplateVideos={galleryDialogSameTemplateVideos}
                    stackedVideoIds={stackedVideoIds}
                /> */}
                <NewGalleryDialog
                    {...this.props}
                    open={isNewGalleryDialogOpen}
                    onClose={this.handleNewGalleryDialogClose}
                    videoInfo={videoInfo}
                    loginRequest={this.loginRequest}
                    clickShareItem={this.clickShareItem}
                    updateVideoInfo={this.GetVideoInfo}
                    heartClick={this.heartClick}
                    moveOriginanlTemplate={this.moveOriginanlTemplate}
                    isOriginalDesignDialogOpened={isOriginalDesignDialogOpened}
                    templateGroupMap={this.templateGroupMap}
                    originalTemplate={originalTemplate}
                    getOriginalTemplateInfo={getOriginalTemplateInfo}
                    closeOrigianlDialog={this.closeOrigianlDialog}
                    updateSelectedTemplate={this.updateSelectedTemplate}
                    onClickSameTemplate={this.handleClickSameTemplate}
                    galleryDialogSameTemplateVideos={galleryDialogSameTemplateVideos}
                    onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
                    onClickGoSeeMoreVideos={this.handleClickGoSeeMoreVideos}
                    stackedVideoIds={stackedVideoIds}
                    onClickReturnBtn={this.handleClickGalleryDialogReturnBtn}
                    onClickHashTag={this.handleClickHashtag}
                    onUpdateHashTag={this.handleUpdateVideoHashTag}
                    date={date}
                />
                <ShareDialog
                    open={this.state.isOpenShareDialog}
                    onClose={this.closeShareDialog}
                    onShare={this.clickShareItem}
                />
                <OneBtnDialog
                    dialogType={this.state.dialogType}
                    open={this.state.isBtnDialogOpened}
                    closeBtn={this.popupHandleCloseBtn}
                    onButtonClick={this.popupHandleCloseBtn}
                />
            </div>
        )
    }

    render() {
        return (
            <div>
                <div className='gallery-video-items'>
                    {this.renderGalleryList()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(MyLikedVideo)